// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, del } from "./api_client";
import { FacilityEventType } from "../models";
import { FacilityEvent, IFacilityEvent, FacilityEventResult, IFacilityEventResult } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getByFacility(facilityId?: string): ApiResult<FacilityEvent[]> {
	return get<IFacilityEvent[]>(`/api/facilityevent/by_facility/${ facilityId }`).then(result => result === undefined ? undefined : result.map(o => new FacilityEvent(o)));
}

export async function getByFacilityPaginated(facilityId?: string, limit?: number, sortKey?: string, sortDirection?: string, eventType?: FacilityEventType, deviceId?: string, trigger?: string, eventValue?: number, dateFrom?: Date, dateTo?: Date, cursor?: string): ApiResult<FacilityEventResult> {
		const queryParams = [limit !== undefined ? `limit=${limit}` : undefined,
			sortKey !== undefined ? `sortKey=${sortKey}` : undefined,
			sortDirection !== undefined ? `sortDirection=${sortDirection}` : undefined,
			eventType !== undefined ? `eventType=${eventType}` : undefined,
			deviceId !== undefined ? `deviceId=${deviceId}` : undefined,
			trigger !== undefined ? `trigger=${trigger}` : undefined,
			eventValue !== undefined ? `eventValue=${eventValue}` : undefined,
			dateFrom !== undefined ? `dateFrom=${dateFrom.toISOString()}` : undefined,
			dateTo !== undefined ? `dateTo=${dateTo.toISOString()}` : undefined,
			cursor !== undefined ? `cursor=${cursor}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IFacilityEventResult>(`/api/facilityevent/by_facility_paginated/${ facilityId }${query}`).then(result => result === undefined ? undefined :  new FacilityEventResult(result));
}

export async function deleteEvent(id?: string): ApiResult<boolean> {
	return del<boolean>(`/api/facilityevent/${ id }`);
}
